/**
 * @file: InspectionTaskEventSubType.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum InspectionTaskEventSubType {
  LicensePlateNoCaptured = 101,
  VinCaptured = 102,
  OrderCreated = 103,
  TaskCreated = 104,
  TaskBasicInfoUpdated = 105,
  OrderInfoUpdated = 106,
  CustomerSigned = 107,
  OrderCanceled = 108,
  OrderDetailUpdated = 109,
  InspectionStarted = 201,
  ItemInspected = 202,
  SiteInspectionStarted = 203,
  SiteInspectionFinished = 204,
  SiteInspectionCancelled = 205,
  CustomIssueAdded = 206,
  CustomIssueUpdated = 207,
  InspectionFinished = 208,
  InspectionReportGenerated = 209,
  InspectionReportUpdated = 210,
  InspectionReportShared = 211,
  InspectionFlowAdded = 212,
  InspectionFlowStarted = 213,
  InspectionFlowCanceled = 214,
  InspectionFlowFinished = 215,
  InspectionCanceled = 216,
  CustomIssueDeleted = 217,
  InspectionFlowAmendRequested = 218,
  InspectionAmendRequested = 219,
  QuotationStarted = 301,
  QuotationInitiated = 302,
  QuotationSubmitted = 303,
  QuotationConfirmed = 304,
  QuotationFinished = 305,
  QuotationPrinted = 306,
  QuotationUpdated = 307,
  QuotationReportGenerated = 308,
  QuotationReportUpdated = 309,
  QuotationReportShared = 310,
  QuotationAmendRequested = 311,
  QuotationCanceled = 312,
  ConstructionConfirmed = 401,
  ConstructionUpdated = 402,
  ConstructionJobBegin = 403,
  ConstructionJobCommitted = 404,
  ConstructionJobCommittedUpdated = 405,
  ConstructionFinished = 406,
  ConstructionReportGenerated = 407,
  ConstructionReportUpdated = 408,
  ConstructionReportShared = 409,
  ConstructionJobCanceled = 410,
  ConstructionCustomJobAdded = 411,
  ConstructionAmendRequested = 412,
  ConstructionProductConfirmed = 413,
  ConstructionProductAdopted = 414,
  CheckListItemReviewed = 802,
  CheckListReviewed = 803,
  CheckListItemRemoved = 807,
  DeliveryCheckReportGenerated = 804,
  DeliveryCheckReportUpdated = 805,
  DeliveryCheckReportShared = 806,
  DeliveryCheckReportAmendRequested = 808,
  DeliveryCheckStarted = 809,
  DeliveryCheckFinished = 810,
  DeliveryCheckCanceled = 811,
  DeliveryCheckListItemUnaccepted = 812,
  DeliveryCheckReworkRecordAdded = 813,
  DeliveryCheckReworkRecordUpdated = 814,
  DeliveryCheckReworkRecordRemoved = 815,
  SamplingCheckStarted = 901,
  SamplingCheckFinished = 902,
  SamplingCheckReportGenerated = 903,
  SamplingCheckReportUpdated = 904,
  SamplingCheckReportAmendRequested = 905,
  SamplingCheckListItemReviewed = 906,
  SamplingCheckListReviewed = 907,
  SamplingCheckListItemRemoved = 908,
  SamplingCheckCanceled = 909,
  SamplingCheckListItemUnaccepted = 910,
  SamplingCheckReworkRecordAdded = 911,
  SamplingCheckReworkRecordUpdated = 912,
  SamplingCheckReworkRecordRemoved = 913,
  Done = 601,
  Closed = 602,
  Rollback = 603,
  PendingIssuesConfirmed = 604,
  PreInspectionStarted = 701,
  PreSiteInspectionStarted = 702,
  PreItemInspected = 703,
  PreSiteInspected = 704,
  PreInspectionFinished = 705,
  PreInspectionReportGenerated = 706,
  PreInspectionReportUpdated = 707,
  PreInspectionReportShared = 708,
  PreInspectionCanceled = 709,
  PreInspectionAmendRequested = 710,
}

export const InspectionTaskEventSubTypeValueSet = new Set([
  InspectionTaskEventSubType.LicensePlateNoCaptured,
  InspectionTaskEventSubType.VinCaptured,
  InspectionTaskEventSubType.OrderCreated,
  InspectionTaskEventSubType.TaskCreated,
  InspectionTaskEventSubType.TaskBasicInfoUpdated,
  InspectionTaskEventSubType.OrderInfoUpdated,
  InspectionTaskEventSubType.CustomerSigned,
  InspectionTaskEventSubType.OrderCanceled,
  InspectionTaskEventSubType.OrderDetailUpdated,
  InspectionTaskEventSubType.InspectionStarted,
  InspectionTaskEventSubType.ItemInspected,
  InspectionTaskEventSubType.SiteInspectionStarted,
  InspectionTaskEventSubType.SiteInspectionFinished,
  InspectionTaskEventSubType.SiteInspectionCancelled,
  InspectionTaskEventSubType.CustomIssueAdded,
  InspectionTaskEventSubType.CustomIssueUpdated,
  InspectionTaskEventSubType.InspectionFinished,
  InspectionTaskEventSubType.InspectionReportGenerated,
  InspectionTaskEventSubType.InspectionReportUpdated,
  InspectionTaskEventSubType.InspectionReportShared,
  InspectionTaskEventSubType.InspectionFlowAdded,
  InspectionTaskEventSubType.InspectionFlowStarted,
  InspectionTaskEventSubType.InspectionFlowCanceled,
  InspectionTaskEventSubType.InspectionFlowFinished,
  InspectionTaskEventSubType.InspectionCanceled,
  InspectionTaskEventSubType.CustomIssueDeleted,
  InspectionTaskEventSubType.InspectionFlowAmendRequested,
  InspectionTaskEventSubType.InspectionAmendRequested,
  InspectionTaskEventSubType.QuotationStarted,
  InspectionTaskEventSubType.QuotationInitiated,
  InspectionTaskEventSubType.QuotationSubmitted,
  InspectionTaskEventSubType.QuotationConfirmed,
  InspectionTaskEventSubType.QuotationFinished,
  InspectionTaskEventSubType.QuotationPrinted,
  InspectionTaskEventSubType.QuotationUpdated,
  InspectionTaskEventSubType.QuotationReportGenerated,
  InspectionTaskEventSubType.QuotationReportUpdated,
  InspectionTaskEventSubType.QuotationReportShared,
  InspectionTaskEventSubType.QuotationAmendRequested,
  InspectionTaskEventSubType.QuotationCanceled,
  InspectionTaskEventSubType.ConstructionConfirmed,
  InspectionTaskEventSubType.ConstructionUpdated,
  InspectionTaskEventSubType.ConstructionJobBegin,
  InspectionTaskEventSubType.ConstructionJobCommitted,
  InspectionTaskEventSubType.ConstructionJobCommittedUpdated,
  InspectionTaskEventSubType.ConstructionFinished,
  InspectionTaskEventSubType.ConstructionReportGenerated,
  InspectionTaskEventSubType.ConstructionReportUpdated,
  InspectionTaskEventSubType.ConstructionReportShared,
  InspectionTaskEventSubType.ConstructionJobCanceled,
  InspectionTaskEventSubType.ConstructionCustomJobAdded,
  InspectionTaskEventSubType.ConstructionAmendRequested,
  InspectionTaskEventSubType.ConstructionProductConfirmed,
  InspectionTaskEventSubType.ConstructionProductAdopted,
  InspectionTaskEventSubType.CheckListItemReviewed,
  InspectionTaskEventSubType.CheckListReviewed,
  InspectionTaskEventSubType.CheckListItemRemoved,
  InspectionTaskEventSubType.DeliveryCheckReportGenerated,
  InspectionTaskEventSubType.DeliveryCheckReportUpdated,
  InspectionTaskEventSubType.DeliveryCheckReportShared,
  InspectionTaskEventSubType.DeliveryCheckReportAmendRequested,
  InspectionTaskEventSubType.DeliveryCheckStarted,
  InspectionTaskEventSubType.DeliveryCheckFinished,
  InspectionTaskEventSubType.DeliveryCheckCanceled,
  InspectionTaskEventSubType.DeliveryCheckListItemUnaccepted,
  InspectionTaskEventSubType.DeliveryCheckReworkRecordAdded,
  InspectionTaskEventSubType.DeliveryCheckReworkRecordUpdated,
  InspectionTaskEventSubType.DeliveryCheckReworkRecordRemoved,
  InspectionTaskEventSubType.SamplingCheckStarted,
  InspectionTaskEventSubType.SamplingCheckFinished,
  InspectionTaskEventSubType.SamplingCheckReportGenerated,
  InspectionTaskEventSubType.SamplingCheckReportUpdated,
  InspectionTaskEventSubType.SamplingCheckReportAmendRequested,
  InspectionTaskEventSubType.SamplingCheckListItemReviewed,
  InspectionTaskEventSubType.SamplingCheckListReviewed,
  InspectionTaskEventSubType.SamplingCheckListItemRemoved,
  InspectionTaskEventSubType.SamplingCheckCanceled,
  InspectionTaskEventSubType.SamplingCheckListItemUnaccepted,
  InspectionTaskEventSubType.SamplingCheckReworkRecordAdded,
  InspectionTaskEventSubType.SamplingCheckReworkRecordUpdated,
  InspectionTaskEventSubType.SamplingCheckReworkRecordRemoved,
  InspectionTaskEventSubType.Done,
  InspectionTaskEventSubType.Closed,
  InspectionTaskEventSubType.Rollback,
  InspectionTaskEventSubType.PendingIssuesConfirmed,
  InspectionTaskEventSubType.PreInspectionStarted,
  InspectionTaskEventSubType.PreSiteInspectionStarted,
  InspectionTaskEventSubType.PreItemInspected,
  InspectionTaskEventSubType.PreSiteInspected,
  InspectionTaskEventSubType.PreInspectionFinished,
  InspectionTaskEventSubType.PreInspectionReportGenerated,
  InspectionTaskEventSubType.PreInspectionReportUpdated,
  InspectionTaskEventSubType.PreInspectionReportShared,
  InspectionTaskEventSubType.PreInspectionCanceled,
  InspectionTaskEventSubType.PreInspectionAmendRequested,
]);
